import * as React from 'react';

import { IWidgetManifest } from '../../../types/widgetManifest';
import { Microfrontend } from '@cian/mf-react';
import { useApplicationContext } from '../../ApplicationContext';
import { useDispatch } from 'react-redux';
import { setPublicationButtonConfig } from '../../../actions/publication';

import { IFVUChangeServicesCustomEvent } from './types';

interface IProps {
  draftGuid?: string | null;
  id?: number | null;
}

export const ServicePickerWidgetContainer = (props: IProps) => {
  const { logger, config } = useApplicationContext();

  const manifest = config.get<IWidgetManifest>('servicePickerWidgetManifest');

  const dispatch = useDispatch();

  const handleFvuServicesChange = React.useCallback(
    ({ detail }: IFVUChangeServicesCustomEvent) => {
      const { shouldSwitchToSelf, notEnoughMoney, unavailableReason } = detail;

      dispatch(setPublicationButtonConfig({ shouldSwitchToSelf, notEnoughMoney, unavailableReason }));
    },
    [dispatch],
  );

  React.useEffect(() => {
    window.addEventListener('fvu-mf-change-services', handleFvuServicesChange);

    return () => {
      window.removeEventListener('fvu-mf-change-services', handleFvuServicesChange);
    };
  }, [handleFvuServicesChange]);

  if (!manifest) {
    logger.error('Отсутствует манифест микрофронта ФВУ', { domain: 'microfrontends.service-picker-widget.manifest' });

    return null;
  }

  return <Microfrontend {...manifest} parameters={{ ...props, hostName: 'addForm' }} />;
};
